module.exports = [{"name":"MTN","prefixes":[],"requireToken":false},{"name":"Airtel","prefixes":[],"requireToken":false},{"name":"GLO","prefixes":[],"requireToken":false},{"name":"Etisalat","prefixes":[],"requireToken":false}]


//////////////////
// WEBPACK FOOTER
// ./src/views/Request/MobileNetworks.json
// module id = 829
// module chunks = 0